module.exports = __webpack_public_path__ + "static/media/1_upload.5765dcba.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/images/product/1_upload.mp4
// module id = 307
// module chunks = 0